<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
      <b-col v-if="hasComplaintsModule" lg="6">
        <div class="search-container">
          <div class="search-input-wrapper">
            <input
              id="protocol-search"
              v-model="protocol"
              class="search-input"
              placeholder="Digite o protocolo ou natureza."
              @keyup.enter="tryOpenProtocol"
            />
            <button
              v-if="protocol"
              class="clear-button"
              type="button"
              @click="clearSearch"
              title="Limpar busca"
            >
              <i class="fas fa-times"></i>
            </button>
            <button
              class="search-button"
              type="button"
              @click="tryOpenProtocol"
            >
              <i class="fas fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </b-col>
      <b-col v-if="showCompanyFilter" lg="3">
        <div class="company-filter-container">
          <searchable-select
            id="company-filter"
            v-model="selectedCompany"
            :options="companyOptions"
            :placeholder="'Todas as Empresas'"
            :search-placeholder="'Buscar empresa...'"
            class="company-filter-select"
          />
        </div>
      </b-col>
      <b-col
        v-if="(isRootUser || isCompanyManager) && showSupportBell"
        cols="12"
        lg="3"
        class="dashboard-bell-col"
      >
        <support-notifications-bell />
      </b-col>
      <!--<b-col v-if="isRootUser" lg="3">
        <div class="ask-ai-container">
          <button class="ask-ai-button" @click="askAI">
            <i class="fas fa-magic" aria-hidden="true"></i>
            <span>Ask AI!</span>
          </button>
        </div>
      </b-col>-->
    </b-row>

    <div v-if="!showingSearchResults">
      <!-- Navegação de Módulos (Tabs) -->
      <div
        v-if="!isRootUser && (isWhitelabel || isCompanyManager)"
        class="module-navigation mb-4"
      >
        <div class="nav-buttons-container d-flex justify-content-center">
          <div class="buttons-group">
            <button
              v-if="hasComplaintsModule"
              class="nav-button"
              :class="{ active: activeModule === 'complaint' }"
              @click="setActiveModule('complaint')"
            >
              Gestão de Relatos
            </button>
            <button
              v-if="hasConformityModule"
              class="nav-button"
              :class="{
                active: activeModule === 'conformity',
                disabled: isRootUser && !selectedCompany,
              }"
              :disabled="isRootUser && !selectedCompany"
              @click="setActiveModule('conformity')"
            >
              Gestão de Conformidade
            </button>
            <button
              v-if="hasDsarModule"
              class="nav-button"
              :class="{
                active: activeModule === 'dsar',
                disabled: isRootUser && !selectedCompany,
              }"
              :disabled="isRootUser && !selectedCompany"
              @click="setActiveModule('dsar')"
            >
              LGPD
            </button>
            <button
              v-if="hasOmbudsmanModule"
              class="nav-button"
              :class="{
                active: activeModule === 'ombudsman',
                disabled: isRootUser && !selectedCompany,
              }"
              :disabled="isRootUser && !selectedCompany"
              @click="setActiveModule('ombudsman')"
            >
              Ouvidoria
            </button>
            <button
              v-if="hasNr1Module"
              class="nav-button"
              :class="{
                active: activeModule === 'nr1',
                disabled: isRootUser && !selectedCompany,
              }"
              :disabled="isRootUser && !selectedCompany"
              @click="setActiveModule('nr1')"
            >
              NR-1
            </button>
            <button
              v-if="hasGrcModule"
              class="nav-button"
              :class="{ active: activeModule === 'grc' }"
              @click="setActiveModule('grc')"
            >
              GRC
            </button>
          </div>
        </div>
      </div>

      <!-- Conteúdo do Módulo: Gestão de Relatos (Dashboard Original) -->
      <div v-if="activeModule === 'complaint'">
        <!--<list-notifications type="complaint"></list-notifications>
      <list-notifications type="dsar"></list-notifications>-->

        <status-metrics :status-data="statusData || []"></status-metrics>

        <!-- Root Dashboard Special Panels -->
        <div v-if="showCompanyFilter" class="dashboard-cards-grid mt-4">
          <!-- 1. Denúncias Não Triadas -->
          <b-card no-body class="h-100 dashboard-card">
            <b-card-body>
              <untriaged-complaints
                :company-id="selectedCompany"
              ></untriaged-complaints>
            </b-card-body>
          </b-card>

          <!-- 2. Denúncias Novas para Usuário (Para Company-Root) -->
          <b-card v-if="isCompanyRoot" no-body class="h-100 dashboard-card">
            <b-card-body>
              <unviewed-complaints-for-user
                :company-id="selectedCompany"
              ></unviewed-complaints-for-user>
            </b-card-body>
          </b-card>

          <!-- 3. Minhas Pendências (Para Company-Root) -->
          <list-pendencies
            v-if="isCompanyRoot"
            :company="selectedCompany"
            class="p-0 m-0"
            :grid-mode="true"
            grid-type="personal"
          ></list-pendencies>

          <!-- 4. Demais Pendências (Para Company-Root) -->
          <list-pendencies
            v-if="isCompanyRoot"
            :company="selectedCompany"
            class="p-0 m-0"
            :grid-mode="true"
            grid-type="other"
          ></list-pendencies>

          <!-- 5. Demais Cards que vêm depois (conforme solicitado: "depois permanece igual") -->
          <b-card no-body class="h-100 dashboard-card" v-if="hasMentionsModule">
            <b-card-body>
              <mentioned-users :company-id="selectedCompany"></mentioned-users>
            </b-card-body>
          </b-card>

          <b-card no-body class="h-100 dashboard-card">
            <b-card-body>
              <inactive-complaints
                :company-id="selectedCompany"
              ></inactive-complaints>
            </b-card-body>
          </b-card>

          <!-- Denúncias não visualizadas pelo cliente -->
          <b-card
            no-body
            class="h-100 dashboard-card"
            v-if="isCompanyRoot || isRootUser"
          >
            <b-card-body>
              <complaints-with-views
                :company-id="selectedCompany"
              ></complaints-with-views>
            </b-card-body>
          </b-card>

          <b-card v-if="!isRootUser" no-body class="h-100 dashboard-card">
            <b-card-body>
              <overdue-pendencies
                :company-id="selectedCompany"
              ></overdue-pendencies>
            </b-card-body>
          </b-card>

          <b-card v-if="!isRootUser" no-body class="h-100 dashboard-card">
            <b-card-body>
              <unread-movements-card
                :company="selectedCompany"
              ></unread-movements-card>
            </b-card-body>
          </b-card>
        </div>

        <!-- Minhas Pendências - Apenas para usuários que não são Company-Root ou que não estão no grid -->
        <list-pendencies
          v-if="isCompanyManager && !isCompanyRoot"
        ></list-pendencies>

        <!-- Original Dashboard Charts -->
        <b-row>
          <b-col lg="8">
            <b-card no-body class="h-100 dashboard-card chart-animation">
              <b-card-body>
                <complaints-per-company-and-status
                  :company-id="selectedCompany"
                >
                </complaints-per-company-and-status>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="4">
            <b-card no-body class="h-100 dashboard-card chart-animation">
              <b-card-body>
                <complaints-per-status :company-id="selectedCompany">
                </complaints-per-status>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- Conteúdo dos Outros Módulos -->
      <div v-else-if="activeModule === 'conformity'">
        <conformity-dashboard
          :company="companyInfo || {}"
          :filter-company-id="selectedCompany"
        ></conformity-dashboard>
      </div>
      <div v-else-if="activeModule === 'dsar'">
        <dsar-dashboard
          :company="companyInfo || {}"
          :filter-company-id="selectedCompany"
        ></dsar-dashboard>
      </div>
      <div v-else-if="activeModule === 'ombudsman'">
        <ombudsman-dashboard
          :company="companyInfo || {}"
          :filter-company-id="selectedCompany"
        ></ombudsman-dashboard>
      </div>
      <div v-else-if="activeModule === 'nr1'">
        <nr1-dashboard
          :company="companyInfo || {}"
          :filter-company-id="selectedCompany"
        ></nr1-dashboard>
      </div>
      <div v-else-if="activeModule === 'grc'">
        <grc-dashboard
          :company="grcDashboardCompany"
          :filter-company-id="selectedCompany"
          :allow-aggregate="showCompanyFilter"
        ></grc-dashboard>
      </div>
    </div>

    <!-- Visualização de Resultados da Busca -->
    <div v-else class="search-results-view py-4">
      <div class="d-flex align-items-center justify-content-between mb-4 px-3">
        <div>
          <h4 class="mb-1 font-weight-bold text-dark">
            <i class="fas fa-search-location mr-2 text-primary"></i>
            Resultados da Busca
          </h4>
          <p class="text-muted small mb-0">
            Exibindo denúncias encontradas para a natureza:
            <strong>"{{ lastSearchTerm }}"</strong>
          </p>
        </div>
        <b-button
          variant="outline-primary"
          class="back-button px-4 shadow-sm"
          @click="backToDashboard"
        >
          <i class="fas fa-arrow-left mr-2"></i> Voltar ao Dashboard
        </b-button>
      </div>

      <b-card no-body class="results-table-card shadow border-0 mx-3">
        <div class="p-0">
          <b-table
            v-if="searchResults.length > 0"
            hover
            :items="searchResults"
            :fields="searchFields"
            responsive="sm"
            class="mb-0 custom-results-table"
            :tbody-tr-class="rowClass"
            @row-clicked="showComplaintSummary"
          >
            <template #cell(companyName)="data">
              <span class="company-name-text">{{ data.item.companyName }}</span>
            </template>
            <template #cell(protocol)="data">
              <a
                href="javascript:void(0)"
                class="protocol-link"
                @click="showComplaintSummary(data.item)"
              >
                {{ data.item.protocol }}
              </a>
            </template>
            <template #cell(status)="data">
              <b-badge
                :variant="getStatusVariant(data.item.status)"
                class="px-2 py-1"
              >
                {{ getStatusLabel(data.item.status) }}
              </b-badge>
            </template>
            <template #cell(createdAt)="data">
              <span class="text-dark">
                {{ new Date(data.item.createdAt).toLocaleString("pt-BR") }}
              </span>
            </template>
            <template #cell(analiseTipo)="data">
              <span class="text-dark">{{ data.item.analiseTipo }}</span>
            </template>
            <template #cell(nature)="data">
              <span class="text-dark">{{ data.item.nature }}</span>
            </template>
          </b-table>
          <div v-else class="text-center py-5">
            <div class="empty-state p-5">
              <div class="icon-circle mb-4 mx-auto">
                <i class="fas fa-search fa-3x text-muted"></i>
              </div>
              <h5 class="font-weight-bold">Nenhum resultado encontrado</h5>
              <p class="text-muted mb-4">
                Nenhuma denúncia corresponde à natureza pesquisada.
              </p>
              <b-button variant="primary" class="px-5" @click="backToDashboard">
                Tentar outra busca
              </b-button>
            </div>
          </div>
        </div>
      </b-card>
    </div>

    <summary-sidebar
      :visible.sync="isSummaryVisible"
      :complaint="selectedComplaint"
      :events="selectedComplaintEvents"
      @close="hideSummary"
    />
  </div>
</template>

<script>
import ComplaintsPerStatus from "./charts/complaints/ComplaintsPerStatus";
import ComplaintsPerCompanyAndStatus from "./charts/complaints/ComplaintsPerCompanyAndStatus";
import UntriagedComplaints from "./charts/complaints/UntriagedComplaints";
import ComplaintsWithViews from "./charts/complaints/ComplaintsWithViews";
import InactiveComplaints from "./charts/complaints/InactiveComplaints";
import OverduePendencies from "./charts/complaints/OverduePendencies";
import MentionedUsers from "./charts/complaints/MentionedUsers";
import UnviewedComplaintsForUser from "./charts/complaints/UnviewedComplaintsForUser";
import UnreadMovementsCard from "./UnreadMovementsCard";
import ListPendencies from "./list-pendencies";
import { mapGetters } from "vuex";
import { companyStatusChart } from "../../api/charts";
import { getCompanies, getCompanyInfo } from "../../api/company";
import protocol from "../../mixins/protocol";
import SearchableSelect from "@/components/SearchableSelect.vue";

import ComplaintDashboard from "./modules/complaint-dashboard";
import ConformityDashboard from "./modules/conformity-dashboard";
import DsarDashboard from "./modules/dsar-dashboard";
import OmbudsmanDashboard from "./modules/ombudsman-dashboard";
import Nr1Dashboard from "./modules/nr1-dashboard";
import GrcDashboard from "./modules/grc-dashboard";
import SummarySidebar from "../complaints/ComplaintsList/SummarySidebar.vue";
import { getComplaint, getEvents } from "@/api/complaint";
import StatusMetrics from "./StatusMetrics";
import SupportNotificationsBell from "./SupportNotificationsBell.vue";

const GRC_MODULES = ["requirements", "risks", "controls", "actionPlans"];

export default {
  name: "DashboardView",
  components: {
    ComplaintsPerCompanyAndStatus,
    ComplaintsPerStatus,
    UntriagedComplaints,
    ComplaintsWithViews,
    InactiveComplaints,
    OverduePendencies,
    UnreadMovementsCard,
    MentionedUsers,
    UnviewedComplaintsForUser,
    ListPendencies,
    SearchableSelect,
    ComplaintDashboard,
    ConformityDashboard,
    DsarDashboard,
    OmbudsmanDashboard,
    Nr1Dashboard,
    GrcDashboard,
    SummarySidebar,
    StatusMetrics,
    SupportNotificationsBell,
  },
  mixins: [protocol],
  data() {
    return {
      showSupportBell: false,
      maxHeight: "100%",
      statusData: [],
      selectedCompany: null,
      companies: [],
      protocol: null,
      activeModule: "complaint",
      companyInfo: null,
      searchResults: [],
      showingSearchResults: false,
      lastSearchTerm: "",
      selectedComplaint: null,
      selectedComplaintEvents: [],
      isSummaryVisible: false,
      searchFields: [
        { key: "companyName", label: "Empresa", sortable: true },
        { key: "protocol", label: "Protocolo", sortable: true },
        { key: "analiseTipo", label: "Termos", sortable: true },
        { key: "nature", label: "Natureza", sortable: true },
        { key: "createdAt", label: "Criada em", sortable: true },
        { key: "status", label: "Status", sortable: true },
      ],
    };
  },
  computed: {
    ...mapGetters(["profile", "permissions"]),
    companyOptions() {
      const options = [{ value: null, text: "Todas as Empresas" }];
      this.companies.forEach((company) => {
        options.push({
          value: company._id,
          text: company.fantasyName || company.name,
        });
      });
      return options;
    },
    isRootUser() {
      return this.profile.role === "root";
    },
    isCompanyManager() {
      return (
        this.profile.role === "company-root" &&
        this.profile.managedCompanies &&
        this.profile.managedCompanies.length > 0
      );
    },
    isWhitelabel() {
      return this.$route.meta && this.$route.meta.whitelabel;
    },
    showCompanyFilter() {
      return this.isRootUser || this.isCompanyManager;
    },
    canSearchByTerm() {
      return (
        this.profile.role === "root" || this.profile.role === "company-root"
      );
    },
    hasComplaintsModule() {
      return this.hasPermission("complaint");
    },
    hasConformityModule() {
      return this.hasPermission("conformity");
    },
    hasDsarModule() {
      return this.hasPermission("dsar");
    },
    hasOmbudsmanModule() {
      return this.hasPermission("ombudsman");
    },
    hasNr1Module() {
      return this.hasPermission("nr1");
    },
    hasGrcModule() {
      return this.hasPermission("grc");
    },
    hasMentionsModule() {
      // Se não há companyInfo carregada, não mostrar
      if (!this.companyInfo) return false;

      // Verificar se o módulo de menções está habilitado
      return this.companyInfo?.modules?.mentions?.enabled === true;
    },
    isSearchTerm() {
      if (!this.canSearchByTerm) return false;
      // Verifica se o valor digitado contém pelo menos uma letra (não é apenas número)
      return /[a-zA-Z]/.test(this.protocol || "");
    },
    showSearchTable() {
      // Retornar falso sempre, pois agora a tabela substitui o dashboard
      return false;
    },
    isCompanyRoot() {
      return this.profile.role === "company-root";
    },
    grcDashboardCompany() {
      if (this.isRootUser && !this.selectedCompany) {
        return {};
      }

      return this.companyInfo || {};
    },
  },
  watch: {
    selectedCompany(newVal) {
      this.loadDashboardData();
      if (this.isRootUser || this.isCompanyManager) {
        if (newVal) {
          this.fetchCompanyInfo(newVal);
        } else {
          if (this.isCompanyManager) {
            this.fetchCompanyInfo(this.profile.company);
          } else {
            this.companyInfo = null;
          }
        }
      }

      // Se já estiver na tela de busca, atualiza os resultados com o novo filtro de empresa
      if (this.showingSearchResults && this.protocol) {
        this.performSearch();
      }
    },
    protocol(newVal) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);

      if (this.isSearchTerm && newVal && newVal.length >= 2) {
        this.searchTimeout = setTimeout(() => {
          this.performSearch();
        }, 300);
      } else {
        this.searchResults = [];
      }
    },
    companyInfo: {
      deep: true,
      handler() {
        this.setInitialActiveModule();
      },
    },
  },
  async mounted() {
    // Para usuários company-root que não gerenciam outras empresas,
    // definir automaticamente a empresa do usuário
    if (this.profile.role === "company-root" && !this.isCompanyManager) {
      this.selectedCompany = this.profile.company;
    }

    if (this.showCompanyFilter) {
      await this.fetchCompanies();
    }
    this.loadDashboardData();

    const companyId = this.profile.company || this.selectedCompany;
    if (companyId) {
      this.fetchCompanyInfo(companyId);
    }
  },
  methods: {
    async fetchCompanyInfo(companyId) {
      try {
        const response = await getCompanyInfo(companyId);
        this.companyInfo = response.data;
        this.setInitialActiveModule();
      } catch (e) {
        console.error("Error loading company info for dashboard:", e);
      }
    },
    dashboardKeyForModule(module) {
      return GRC_MODULES.includes(module) ? "grc" : module;
    },
    resolvePermissionKey(module) {
      return module === "nr1" ? "questionnaire" : module;
    },
    hasPermission(module) {
      if (module === "grc") {
        if (typeof this.profile.role === "string") {
          if (!this.companyInfo || !this.companyInfo.modules) {
            return this.profile.role === "company-root";
          }

          return GRC_MODULES.some(
            (grcModule) => this.companyInfo.modules?.[grcModule]?.enabled
          );
        }

        return GRC_MODULES.some(
          (grcModule) => this.permissions?.[grcModule]?.read === true
        );
      }

      if (typeof this.profile.role === "string") {
        if (this.companyInfo && this.companyInfo.modules) {
          return this.companyInfo.modules?.[module]?.enabled === true;
        }

        return true;
      }
      const permissionKey = this.resolvePermissionKey(module);
      if (this.permissions && this.permissions[permissionKey]) {
        return this.permissions[permissionKey].read;
      }
      return false;
    },
    getAvailableDashboardModules() {
      if (!this.companyInfo || !this.companyInfo.modules) {
        return ["complaint"];
      }

      const dashboards = [];
      Object.keys(this.companyInfo.modules).forEach((module) => {
        if (!this.companyInfo.modules[module]?.enabled) {
          return;
        }

        if (!this.hasPermission(module)) {
          return;
        }

        const dashboardKey = this.dashboardKeyForModule(module);
        if (!dashboards.includes(dashboardKey)) {
          dashboards.push(dashboardKey);
        }
      });

      return dashboards.length > 0 ? dashboards : ["complaint"];
    },
    setInitialActiveModule() {
      const availableModules = this.getAvailableDashboardModules();
      if (!availableModules.includes(this.activeModule)) {
        this.activeModule = availableModules[0];
      }
    },
    setActiveModule(module) {
      this.activeModule = module;
    },
    async fetchCompanies() {
      console.log(
        "fetchCompanies called - isRootUser:",
        this.isRootUser,
        "isCompanyManager:",
        this.isCompanyManager
      );
      try {
        if (this.isRootUser) {
          // Root user: carregar todas as empresas (paginado)
          const response = await getCompanies({ size: 1000, page: 1 });
          console.log("Root user - companies response:", response.data);
          this.companies = Array.isArray(response.data)
            ? response.data
            : response.data.docs || [];
        } else if (this.isCompanyManager) {
          // Company-root gestora: a API já retorna a própria empresa + empresas gerenciadas
          const response = await getCompanies();
          console.log("Company manager - companies response:", response.data);
          // Resposta pode ser array direto ou paginada
          this.companies = Array.isArray(response.data)
            ? response.data
            : response.data.docs || [];
        }
        console.log("Companies loaded:", this.companies);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    },
    async loadDashboardData() {
      const company = this.showCompanyFilter
        ? this.selectedCompany
        : this.profile.company;
      try {
        const response = await companyStatusChart(company, "complaint");
        this.statusData = response.data;
      } catch (error) {
        console.error("Error fetching status data:", error);
      }
    },
    async tryOpenProtocol() {
      if (!this.protocol) return;

      if (!this.isSearchTerm) {
        await this.openProtocol(this.protocol);
        this.protocol = null;
      } else {
        this.lastSearchTerm = this.protocol;
        await this.performSearch();
        this.showingSearchResults = true;
      }
    },
    async performSearch() {
      const res = await this.openProtocol(this.protocol, {
        preventRedirect: true,
        companyId: this.selectedCompany,
      });
      if (res && res.results) {
        this.searchResults = res.results;
      } else if (res && res._id) {
        this.searchResults = [res];
      } else {
        this.searchResults = [];
      }
    },
    backToDashboard() {
      this.showingSearchResults = false;
      this.searchResults = [];
      this.protocol = null;
    },
    clearSearch() {
      this.protocol = null;
      if (this.showingSearchResults) {
        this.backToDashboard();
      }
    },
    goToProtocol(item) {
      this.$router.push({ path: `/denuncias/${item._id}` });
    },
    async showComplaintSummary(complaint) {
      try {
        this.selectedComplaintEvents = [];
        this.isSummaryVisible = true;

        const complaintResponse = await getComplaint(complaint._id);
        if (complaintResponse && complaintResponse.data) {
          this.selectedComplaint = complaintResponse.data;
        } else {
          this.selectedComplaint = complaint;
        }

        const eventsResponse = await getEvents(complaint._id);
        if (eventsResponse && eventsResponse.data) {
          this.selectedComplaintEvents = Array.isArray(eventsResponse.data)
            ? eventsResponse.data
            : eventsResponse.data.events || [];
        }
      } catch (error) {
        console.error("Erro ao carregar dados da denúncia:", error);
        this.selectedComplaint = complaint;
        this.selectedComplaintEvents = [];
        this.$bvToast.toast(
          "Não foi possível carregar todos os dados da denúncia",
          {
            title: "Aviso",
            variant: "warning",
            solid: true,
          }
        );
      }
    },
    hideSummary() {
      this.isSummaryVisible = false;
      this.selectedComplaint = null;
      this.selectedComplaintEvents = [];
    },
    getStatusLabel(status) {
      const labels = {
        0: "Nova",
        1: "Em processamento",
        2: "Concluída",
        3: "Encerrada",
      };
      return labels[parseInt(status)] || "Indefinido";
    },
    getStatusVariant(status) {
      const variants = {
        0: "primary",
        1: "warning",
        2: "success",
        3: "dark",
      };
      return variants[parseInt(status)] || "secondary";
    },
    askAI() {
      console.log("Ask AI clicked");
    },
    rowClass(item) {
      if (!item) return "";
      const status = parseInt(item.status);
      return `status-row-${status}`;
    },
  },
};
</script>

<style scoped>
.dashboard-cards-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

@media (max-width: 991px) {
  .dashboard-cards-grid {
    grid-template-columns: 1fr;
  }
}

.h-100 {
  height: 100% !important;
}

.dashboard-bell-col {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

@media (max-width: 991px) {
  .dashboard-bell-col {
    justify-content: flex-start;
    margin-top: 0.75rem;
  }
}

/* Estilos do campo de busca */
.search-container {
  position: relative;
  width: 100%;
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.search-input {
  flex: 1;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  color: #4a5568;
  background-color: transparent;
  outline: none;
}

.search-input::placeholder {
  color: #4a5568;
}

.search-button {
  background-color: transparent;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  margin-right: 0;
}

.search-button:hover {
  opacity: 0.7;
}

.search-button i {
  color: #000000;
  font-size: 0.9rem;
}

/* Estilos do filtro de empresa */
.company-filter-container {
  position: relative;
  width: 100%;
}

.company-filter-select {
  width: 100%;
  height: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  color: #4a5568;
  background-color: white;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.company-filter-select:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.ask-ai-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.ask-ai-button {
  width: 40%;
  height: 100%;
  background-color: black;
  border: 1px solid #cbcbcb;
  border-radius: 12px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-weight: 500;
}

.ask-ai-button:hover {
  background-color: #212529;
  border-color: #cbcbcb;
}

.ask-ai-button i {
  color: white;
}

/* Navegação de Módulos (mesmo estilo do CompanyDashboard) */
.module-navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
}

.nav-buttons-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.buttons-group {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.nav-button {
  padding: 0.6rem 2rem;
  border-radius: 30px;
  border: 1px solid #e2e8f0;
  background-color: white;
  color: #4a5568;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  font-size: 1rem;
}

.nav-button:hover {
  border-color: #007bff;
  color: #007bff;
  transform: translateY(-2px);
}

.nav-button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.35);
}

.nav-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  filter: grayscale(1);
}

/* Estilos da Visualização de Resultados */
.search-results-view {
  background-color: #f8fafc;
  border-radius: 12px;
  min-height: calc(100vh - 200px);
}

.results-table-card {
  border-radius: 16px;
  overflow: hidden;
}

.custom-results-table ::v-deep th {
  background-color: #f8fafc !important;
  color: #64748b !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  padding: 1rem 1.5rem !important;
  border-top: none !important;
  border-bottom: 2px solid #e2e8f0 !important;
}

.custom-results-table ::v-deep td {
  padding: 1rem 1.5rem !important;
  vertical-align: middle !important;
  border-bottom: 1px solid #f1f5f9 !important;
  color: #334155;
  background-color: transparent !important;
  font-size: 0.85rem;
}

.custom-results-table ::v-deep tr {
  background-color: white !important;
  transition: all 0.2s ease;
}

.company-name-text {
  color: #334155;
  font-weight: 700;
  font-size: 0.85rem;
}

/* Status Indicators (Gradient) */
/* Status 0: Nova (Blue) */
.custom-results-table ::v-deep .status-row-0 {
  background: linear-gradient(
    90deg,
    rgba(37, 99, 235, 0.08) 0%,
    rgba(255, 255, 255, 0) 15%,
    #ffffff 100%
  ) !important;
}

/* Status 1: Em processamento (Yellow) */
.custom-results-table ::v-deep .status-row-1 {
  background: linear-gradient(
    90deg,
    rgba(255, 193, 7, 0.12) 0%,
    rgba(255, 255, 255, 0) 15%,
    #ffffff 100%
  ) !important;
}

/* Status 2: Concluída (Green) */
.custom-results-table ::v-deep .status-row-2 {
  background: linear-gradient(
    90deg,
    rgba(40, 167, 69, 0.08) 0%,
    rgba(255, 255, 255, 0) 15%,
    #ffffff 100%
  ) !important;
}

/* Status 3: Encerrada (Dark/Gray) */
.custom-results-table ::v-deep .status-row-3 {
  background: linear-gradient(
    90deg,
    rgba(52, 58, 64, 0.05) 0%,
    rgba(255, 255, 255, 0) 15%,
    #ffffff 100%
  ) !important;
}

.custom-results-table ::v-deep tr:hover {
  background-color: #f8fafc !important;
}

.custom-results-table ::v-deep tr:hover td {
  background-color: transparent !important;
  cursor: pointer;
}

.protocol-link {
  font-weight: 700;
  color: #2563eb;
  text-decoration: none;
}

.protocol-link:hover {
  text-decoration: underline;
  color: #1d4ed8;
}

.back-button {
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.9rem;
  border-width: 2px;
  transition: all 0.2s ease;
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15) !important;
}

.clear-button {
  background: transparent;
  border: none;
  color: #94a3b8;
  padding: 0 0.8rem;
  cursor: pointer;
  transition: color 0.2s;
  font-size: 1.1rem;
}

.clear-button:hover {
  color: #ef4444;
}

.icon-circle {
  width: 80px;
  height: 80px;
  background-color: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn {
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
